var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161.5 172.3",
    style: {
      enableBackground: "new 0 0 161.5 172.3",
      fill: "currentColor"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-calendar",
    d: "M53.8,64.6h21.5v21.5H53.8V64.6z M86.1,64.6h21.5v21.5H86.1V64.6z M21.5,129.2h21.5v21.5H21.5 V129.2z M53.8,129.2h21.5v21.5H53.8V129.2z M86.1,129.2h21.5v21.5H86.1V129.2z M53.8,96.9h21.5v21.5H53.8V96.9z M86.1,96.9h21.5 v21.5H86.1V96.9z M118.4,96.9H140v21.5h-21.5L118.4,96.9z M21.5,96.9h21.5v21.5H21.5L21.5,96.9z M140,0v10.8h-21.5V0H43.1v10.8H21.5 V0H0v172.3h161.5V0H140z M150.7,161.5h-140V43.1h140V161.5z M140,86.1h-21.5V64.6H140V86.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.7220d84b530d7e6a8b89aab4d7b1b179.svg";
export { ForwardRef as ReactComponent };